<template>
  <div class="table-wrapper cover-content project-list">
    <!-- 查询条件 -->
    <Form
      ref="formInline"
      :model="formInline"
      inline
      class="form-list"
      :label-width="100"
      label-position="right">
      <Row :gutter="16">
        <Col span="5">
          <FormItem label="项目名称:" prop="projectNname" >
            <Input
              v-model="formInline.projectNname"
              placeholder="请输入项目名称"  clearable
            ></Input>
          </FormItem>
        </Col>
        <Col span="5">
          <FormItem label="人员姓名:" prop="workerName" >
            <Input
              v-model="formInline.workerName"
              placeholder="请输入人员姓名"  clearable
            ></Input>
          </FormItem>
        </Col>
        <Col span="5">
          <FormItem label="性别:" prop="gender" >
            <Select
              v-model="formInline.gender"
              clearable
              placeholder="请选择"
            >
                <Option value="0">男</Option>
                <Option value="1">女</Option>
              >
            </Select>
          </FormItem>
        </Col>
        <Col span="5">
          <FormItem label="街镇:" prop="areaCode" >
            <Select
              v-model="formInline.areaCode"
              placeholder="请选择"
              clearable
            >
              <Option
                v-for="(item, index) in Suppliers"
                :key="index"
                :label="item.name"
                :value="item.code"
                >{{ item.name }}</Option
              >
            </Select>
          </FormItem>
        </Col>
        <Col span="4" class="high-search">
          <Button type="primary" @click="handleQuery">查询</Button>
          <Button style="margin-left: 20px" @click="handleReset">重置</Button>
          <!-- <span
            :class="open ? 'search-open' : 'search-close'"
            @click="open = !open"
            >{{ open ? "收起" : "展开" }}
            <Icon :type="open ? 'ios-arrow-up' : 'ios-arrow-down'"
          /></span> -->
        </Col>
        </Row>
      <Row :gutter="16" v-show="open">
        <Col span="5">
          <FormItem label="用工单位:" prop="corpName" >
            <Input
              v-model="formInline.corpName"
              placeholder="请输入用工单位"  clearable
            ></Input>
          </FormItem>
        </Col>
        <Col span="5">
          <FormItem label="建设单位:" prop="buildCorpName" >
            <Input
              v-model="formInline.buildCorpName"
              placeholder="请输入建设单位"  clearable
            ></Input>
          </FormItem>
        </Col>
        <Col span="5">
          <FormItem label="施工单位:" prop="winUnit" >
            <Input
              v-model="formInline.winUnit"
              placeholder="请输入施工单位"  clearable
            ></Input>
          </FormItem>
        </Col>
        <Col span="5">
          <FormItem label="身份证号：" prop="idCardNumber">
            <Input v-model="formInline.idCardNumber" placeholder="请输入身份证号" clearable></Input>
          </FormItem>
        </Col>
      </Row>
      <Row>
        <Col span="8">
          <Button style="margin-bottom:24px;" type="primary" icon="ios-exit-outline" @click="handleExport">批量导出</Button>
        </Col>
      </Row>
    </Form>
    <!-- 表格数据 -->
     <Table :loading="loading" border :columns="tableColumns" :data="tableData" highlight-row> </Table>
     <!-- 分页 -->
     <div class="t-page">
        <Page :total="totalCount" :page-size="pageSize" :current="page"
              @on-change="changePage" @on-page-size-change="pageSizeChange"
              show-elevator show-sizer show-total transfer>
        </Page>
    </div>
  </div>
</template>

<script>
import tableMixin from '@/components/tableMixin';
export default {
    mixins: [tableMixin],
    data () {
        return {
          Suppliers:[],
            open: true,
            formInline: {
                //项目名称：
                projectNname: '',
                //人员姓名
                workerName: '',
                //性别
                gender: '',
                //街镇
                areaCode: localStorage.getItem('tenantAreaCode'),
                //用工单位
                corpName: '',
                //建设单位
                buildCorpName: '',
                //施工单位
                winUnit: '',
                //身份证号：
                idCardNumber: '',

                projectId:''
            },
            tableData:[],
            tableColumns:[
                {
                    type: 'index',
                    title: '序号',
                    width: 70,
                    align: 'center'
                },
                {
                    title: '项目名称',
                    key: 'projectNname',
                    minWidth:100,
                    tooltip: true
                },
                {
                    title: '人员姓名',
                    key: 'workerName',
                    tooltip: true,
                    minWidth:100,
                },
                {
                    title: '性别',
                    key: 'gender',
                    tooltip: true,
                    minWidth:100,
                },
                {
                    title: '街镇',
                    key: 'streetName',
                    tooltip: true,
                    minWidth:100,
                },
                {
                    title: '身份证',
                    key: 'idCardNumber',
                    minWidth:100,
                    tooltip: true
                },
                {
                    title: '用工单位',
                    key: 'corpName',
                    minWidth:100,
                    tooltip: true
                },
                {
                    title: '建设单位',
                    key: 'buildCorpName',
                    minWidth:100,
                    tooltip: true
                },
                {
                    title: '施工单位',
                    key: 'winUnit',
                    minWidth:100,
                    tooltip: true
                }
            ],
        }
    },
    created () {
      this.getqueryStreet()
    },
    methods: {
        /*批量导出*/
        handleExport() {
            let param = {
              size: this.pageSize,
              current: this.page,
              ...this.formInline,

            };
           this.axios({
                 method: 'post',
                 url:'/warn/queryWorkerExport',
                 responseType:'arraybuffer',
                 data: param,
              }).then( (response)=> {
                 this.common.download(response,'预警人员管理.xls','application/vnd.ms-excel');
            });
        },
        /*重置*/
        handleReset() {
            this.formInline = {}
            this.getTableData()
        },
        /*获取表格数据*/
        getTableData(){
            let param = {
              size: this.pageSize,
              current: this.page,
              ...this.formInline,
              // gender:this.formInline.gender-0
            };
            // if(!this.formInline.areaCode){
            //   this.formInline.areaCode = localStorage.getItem('tenantAreaCode')
            // }
            if(!this.formInline.areaCode){
              param.areaCode = localStorage.getItem('tenantAreaCode')
            }
            console.log(this.formInline)
            this.loading=true;
            this.axios({
                method: 'post',
                url: '/warn/queryWorker',
                data:param
            }).then( (res)=> {
              this.loading=false;
              console.log(res,'========');
                if (res.data.success){
                    this.totalCount = res.data.data.total;
                    this.tableData=res.data.data.records;
                }
            }).catch( ()=> {
                    this.loading=false;
              });
        },
        /*获取街镇*/
        getqueryStreet(){
          this.axios({
                method: 'get',
                url: '/warn/queryStreet',
                params:{
                  code:310120
                }
            }).then( (res)=> {
                if (res.data.success){
                    this.Suppliers = res.data.data;
                }
            })
        }
    }
}
</script>

<style>

</style>